import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { PageHyundaiPromise } from '../../api/api-types';

export const actions = createActionGroup({
    source: 'HyundaiPromise',
    events: {
        'Load Hyundai Promise': emptyProps(),
        'Load Hyundai Promise Success': props<{ content: PageHyundaiPromise }>(),
        'Load Hyundai Promise Failure': props<{ error: string }>(),
    },
});
